import { render, staticRenderFns } from "./RegisterFormComp.vue?vue&type=template&id=4e2b9f70&scoped=true"
import script from "./RegisterFormComp.vue?vue&type=script&lang=ts"
export * from "./RegisterFormComp.vue?vue&type=script&lang=ts"
import style0 from "./RegisterFormComp.vue?vue&type=style&index=0&id=4e2b9f70&prod&lang=scss&scoped=true"
import style1 from "./RegisterFormComp.vue?vue&type=style&index=1&id=4e2b9f70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2b9f70",
  null
  
)

export default component.exports